import { BaseApi } from '@/helpers/base-api'

export default class OffersApi extends BaseApi {
  constructor () {
    super('/api/v1/offers')
    this.errorMessage = 'There was an issue when trying to fetch the offers. If this error persists, please contact our support.'
  }

  public getAllOffers = (query: string): Promise<OfferDto[] | OfferResponseDto> => this.instance.get(`${query}`);

  public getOfferPdfExport = (data: Record<string, unknown>): Promise<Blob> => this.instance.post(`/${data.offerId}/export`, data, { responseType: 'blob' });

  public createOffer = (data: Record<string, any>): Promise<OfferDto> => this.instance.post('', data);

  public createOfferLineItem = (data: Record<string, any> | Record<string, any>[]): Promise<OfferDto> => {
    const offerId = Array.isArray(data) ? data[0]?.offerId : data.offerId;

    return this.instance.post(`/${offerId}/line-items`, data);
  };

  public getOffersPdfExportAction = (query: string, data: Record<string, unknown>): Promise<Blob> => this.instance.post(`/export${query}`, data, { responseType: 'blob' })

  public updateOfferLineItem = (data: Record<string, unknown>): Promise<JSON> => this.instance.patch(`/${data.offer_id}/line-items/${data.line_item_id}`, data);

  public deleteOfferLineItem = (data: Record<string, any>): Promise<string> => this.instance.delete(`/${data.offerId}/line-items/${data.lineItemId}`);

}
